import React from "react";
import CoachingStaff from "../components/coaching-staff/CoachingStaff";

const CoachingStaffContainer = () => <CoachingStaff />;

CoachingStaffContainer.displayName = "CoachingStaffContainer";

export default CoachingStaffContainer;
